export type PressMention = {
    id: string
    outlet: string
    title: string
    date: string
    dateLabel: string
    url: string
    excerpt: string
}

/** Newest first. Dates use the article's published day when known; month-only sources use the 1st. */
export const PRESS_MENTIONS: PressMention[] = [
    {
        id: 'profesional-horeca-hip-2026',
        outlet: 'Profesional Horeca',
        title: 'Llega el asistente de voz que detecta errores en facturas de proveedores',
        date: '2026-03-01',
        dateLabel: 'Marzo 2026',
        url: 'https://www.profesionalhoreca.com/llega-el-asistente-de-voz-que-detecta-errores-en-facturas-de-proveedores/',
        excerpt:
            'Tipi presenta en HIP 2026 un asistente de voz con IA que crea escandallos en segundos y ha detectado errores de hasta 8.000 € en facturas de proveedores.',
    },
    {
        id: 'infohoreca-escandallos-voz',
        outlet: 'InfoHoreca',
        title: 'Asistente de voz que detecta errores de hasta 8.000€ en facturas y crea escandallos en segundos',
        date: '2026-02-25',
        dateLabel: '25 feb 2026',
        url: 'https://www.infohoreca.com/productos/20260225/tipi-escandallos-por-voz-en-segundos-control-costes',
        excerpt:
            'Cobertura del asistente de Tipi en HIP: escandallos por voz, control de costes y reconocimiento como ganadora del Future Gastronomy Startup Forum.',
    },
    {
        id: 'nuevo-digital-murcia-hip',
        outlet: 'El Nuevo Digital Murcia',
        title: 'La startup murciana Tipi triunfa con su asistente de voz para elaborar escandallos en segundos',
        date: '2026-02-20',
        dateLabel: '20 feb 2026',
        url: 'https://elnuevodigitalmurcia.es/art/7211/la-startup-murciana-tipi-triunfa-con-su-asistente-de-voz-para-elaborar-escandallos-en-segundos',
        excerpt:
            'Tipi gana el Future Gastronomy Startup Forum en HIP 2026 y se integra en el ecosistema de GOe y el Basque Culinary Center.',
    },
    {
        id: 'murcia-com-hip',
        outlet: 'Murcia.com',
        title: 'La startup murciana Tipi gana el Future Gastronomy Startup Forum en HIP y se integra en el ecosistema del Basque Culinary Center',
        date: '2026-02-20',
        dateLabel: '20 feb 2026',
        url: 'https://www.murcia.com/empresas/noticias/2026/02/20-la-startup-murciana-tipi-gana-el-future-gastronomy-startup-forum-en-hip-y-se-integra-en-el-ecosistem.asp',
        excerpt:
            'Reconocimiento en HIP 2026 por devolver el control económico al hostelero desde la cocina con un asistente de voz basado en IA.',
    },
    {
        id: 'la-opinion-murcia-hip',
        outlet: 'La Opinión de Murcia',
        title: 'De la cocina murciana al podio europeo: Tipi corona su revolución gastronómica con inteligencia artificial',
        date: '2026-02-20',
        dateLabel: '20 feb 2026',
        url: 'https://www.laopiniondemurcia.es/ocio/gastronomia/2026/02/20/cocina-murciana-podio-europeo-tipi-127084977.html',
        excerpt:
            'La Opinión de Murcia cubre la victoria de Tipi en el Future Gastronomy Startup Forum y su proyección en el ecosistema del Basque Culinary Center.',
    },
    {
        id: 'murcia-plaza-ronda',
        outlet: 'Murcia Plaza',
        title: 'La murciana Tipi ultima una ronda de 100.000 euros y busca alcanzar la rentabilidad en seis meses',
        date: '2025-09-11',
        dateLabel: '11 sep 2025',
        url: 'https://murciaplaza.com/murciaplaza/empresas-murcia/la-murciana-tipi-ultima-una-ronda-de-100000-euros-y-busca-alcanzar-la-rentabilidad-en-seis-meses',
        excerpt:
            'Tipi entra en Lanzadera y avanza una ronda de 100.000 € para escalar su asistente de voz de gestión para restaurantes.',
    },
    {
        id: 'ecosistema-startup-ronda',
        outlet: 'El Ecosistema Startup',
        title: 'Tipi cierra ronda de 100.000 euros y busca rentabilidad en seis meses',
        date: '2025-09-11',
        dateLabel: '11 sep 2025',
        url: 'https://ecosistemastartup.com/tipi-cierra-ronda-de-100-000-euros-y-busca-rentabilidad-en-seis-meses/',
        excerpt:
            'Cobertura de la ronda de Tipi y de su ingreso en Lanzadera dentro del ecosistema startup de restauración.',
    },
    {
        id: 'las-gastrocronicas-entrevista',
        outlet: 'Las Gastrocrónicas',
        title: 'Jóvenes murcianos crean Tipi: el asistente de voz que rescata a los chefs de los papeles y los devuelve a los fogones',
        date: '2025-09-10',
        dateLabel: '10 sep 2025',
        url: 'https://lasgastrocronicas.com/jovenes-murcianos-crean-tipi-el-asistente-de-voz-que-rescata-a-los-chefs-de-los-papeles-y-los-devuelve-a-los-fogones/',
        excerpt:
            'Entrevista al equipo Tipi sobre el origen del producto, Lanzadera y cómo la voz elimina la burocracia en cocina.',
    },
]
